import {createSelector} from '@ngrx/store';
import {getStoreSelector} from '@shared/helpers/store/selectors.helper';

/** Auxiliary 'createCtsDistributionSelector' variable. */
const createCtsDistributionSelector = getStoreSelector('ctsDistribution');

/**
 * Auxiliary constant declaration with selectors for CTS Distribution page.
 */
export const ctsDistributionSelectors = {
	table: {
		data: createSelector(createCtsDistributionSelector('table'), (table) => table.data),
		filters: createCtsDistributionSelector('tableFilters'),
		sorting: createCtsDistributionSelector('tableSorting'),
		loadingStatus: createCtsDistributionSelector('tableLoadingStatus'),
	},
	platforms: {
		data: createCtsDistributionSelector('platforms'),
		loadingStatus: createCtsDistributionSelector('platformsLoadingStatus'),
	},
	periodFilter: {
		data: createCtsDistributionSelector('periodFilter'),
		loadingStatus: createCtsDistributionSelector('periodFilterLoadingStatus'),
	},
	programTypeFilter: {
		data: createCtsDistributionSelector('programTypeFilter'),
		loadingStatus: createCtsDistributionSelector('programTypeFilterLoadingStatus'),
	},
	savedRows: {
		data: createCtsDistributionSelector('savedRows'),
		loadingStatus: createCtsDistributionSelector('savedRowsLoadingStatus'),
	},
	pagination: {
		currentPage: createCtsDistributionSelector('currentPage'),
		pagesCount: createCtsDistributionSelector('pagesCount'),
		pagesCountLoadingStatus: createCtsDistributionSelector('pagesCountLoadingStatus'),
	},
	historicalDate: createCtsDistributionSelector('historicalDate'),
};
